// extracted by css-extract-rspack-plugin
export default {"ReadonlyCommentBoxContainer":"ReadonlyCommentBox-module__ReadonlyCommentBoxContainer__Af_Ntar","centeredContent":"ReadonlyCommentBox-module__centeredContent__BDUdX1i"};